// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://rmqhbqlsdtdfsmvhdytq.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJtcWhicWxzZHRkZnNtdmhkeXRxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Njk2MDIxMDUsImV4cCI6MjA4NTE3ODEwNX0.sPRmR7_WEIap19u552M3tnFPfOJThHvwINZ1_0QVsS8";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  }
});